<template>
  <div class="">
    <!-- <gi-title :data="this.infoData.title1"></gi-title> -->
    <div class="container1">
      <div class="container">
        <div class="join-right">
          <h3>{{infoData.title1}}</h3>
          <img :src="this.infoData['二维码']" alt="">
          <p class="" v-if="infoData.title2">{{infoData.title2}}</p>
          <p class="" v-if="infoData.text">{{infoData.text}}</p>
        </div>
        <div class="join-left">
          <img :src="this.infoData['二维码']" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GiTitle from '../title'
export default {
  props: {
    infoData: {
      type: Object
    }
  },
  components: {
    GiTitle
  }
}
</script>

<style lang="scss" scoped>
@mixin mobile {
  @media screen and (max-width: 769px) {
    @content
  }
};
@mixin tablet {
  @media screen and (min-width: 780px) {
    @content
  }
};
.container1 {
  background: url('../../assets/banner-03.png') no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  .container {
    @include tablet {
      width: 1100px;
      display: flex;
      padding: 20px 0px;
    }
    @include mobile() {
      display: block;
      width: 100%;
      padding: 20px 0px;
    }
    .join-left {
      flex: 3;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 100px;
        height: 100px;
      }
      @include mobile() {
        display: none;
      }
    }
    .join-right {
      flex: 3;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @include tablet {
        margin-left: 174px;
      }
      h3 {
        font-size: 22px;
        margin-bottom: 30px;
        font-weight: bold;
        @include mobile() {
          font-size: 20px;
          margin-bottom: 20px;
        }
      }
      p {
        font-size: 16px;
        @include mobile() {
          font-size: 14px;
        }
      }
      img {
        @include tablet {
          display: none;
        }
        @include mobile() {
          display: block;
          width: 100px;
          height: 100px;
          margin: 0px auto;
          margin-bottom: 20px;
        }
      }
      @include mobile() {
        display: block;
        width: 100%;
        text-align: center;
        font-size: 14px;
        margin-top: 20px;
      }
    }
  }
  
}
</style>
